<template>
    <div>
        <textarea ref="input"
                  :value="data">
        </textarea>
    </div>
</template>

<script>
	export default {
		name: "TextArea",
		props: {
			data: {
				required: true
			}
		},
		methods: {
			getValue() {
				return this.$refs.input.value;
			}
		}
	}
</script>

<style scoped>
    textarea {
        width: 100%;
        max-width: 600px;
        height: 60px;
        box-sizing: border-box;
    }

    div {
        height: auto;
    }
</style>